/**
 * Created by Ning Jiang on 10/29/2019.
 */

import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {ZeroBetController} from "@nolimitcity/slot-game/bin/core/zerobet/ZeroBetController";
import {DeadwoodGameMode} from "../gamemode/DeadwoodGameMode";

export class DWFreespinZeroBetController extends ZeroBetController {

    constructor() {
        super();
    }

    protected getZeroBetNumberLeft(data:ParsedServerData):number {
        return data.freespinsLeft;
    }

    public shouldSubtractZeroBetCounter():boolean {
        return true;
    }

    public shouldShowZeroBetCounter():boolean {
        return true;
    }

    protected calculateIsTriggered(data:ParsedServerData):boolean {
        return data.nextMode === DeadwoodGameMode.FREESPIN_GUNSLINGER
            || data.nextMode === DeadwoodGameMode.FREESPIN_HUNTERS;
    }
}